// extracted by mini-css-extract-plugin
export default {"recordLinkageHeaderRow":"recordLinkageHeaderRow---JNQNV","recordLinkageHeaderCell":"recordLinkageHeaderCell---ozPss","asterisk":"asterisk---VdRH1"};